module.exports = __webpack_public_path__ + "static/junior-9-f0a1df8fa37d6cec08a2f67c1f46fab7.png";